// =============================================
// COMPONENTE: EmailNode - Nó de Email
// =============================================
// Arquivo: EmailNode.tsx
// Descrição: Nó para envio de emails com templates e anexos
// =============================================

import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Mail, FileText, Users } from 'lucide-react';
import ActionsBadge from './ActionsBadge';
import '../NodeStyles.css';

const EmailNode: React.FC<NodeProps> = ({ data, selected }) => {
  const {
    label,
    to,
    subject,
    template,
    hasAttachments = false,
    cc,
    bcc,
    description,
    actions
  } = data;

  return (
    <div className={`flow-node email-node ${selected ? 'selected' : ''}`}>
      <Handle
        type="target"
        position={Position.Top}
        className="flow-handle"
      />

      <div className="node-header email-header">
        <Mail className="node-icon" size={18} />
        <span className="node-title">{label || 'Send Email'}</span>
      </div>

      <div className="node-body">
        {to && (
          <div className="node-detail">
            <Users size={14} />
            <span className="node-detail-text">
              Para: {to.substring(0, 30)}{to.length > 30 ? '...' : ''}
            </span>
          </div>
        )}
        {subject && (
          <div className="node-detail">
            <Mail size={14} />
            <span className="node-detail-text">
              {subject.substring(0, 35)}{subject.length > 35 ? '...' : ''}
            </span>
          </div>
        )}
        {hasAttachments && (
          <div className="node-badge">
            <FileText size={12} /> Anexos
          </div>
        )}
        {(cc || bcc) && (
          <div className="node-badge">
            {cc ? 'CC' : ''}{cc && bcc ? ' • ' : ''}{bcc ? 'BCC' : ''}
          </div>
        )}
        {template && (
          <div className="node-badge success">
            📄 Template: {template}
          </div>
        )}
        {description && (
          <div className="node-description">{description}</div>
        )}
        <ActionsBadge actions={actions} />
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        className="flow-handle"
      />
    </div>
  );
};

export default EmailNode;
